module.exports = {
  siteTitle: 'Farhana Shahid', // <title>
  manifestName: 'Resume',
  manifestShortName: 'Landing', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  firstName: 'Farhana ',
  lastName: 'Shahid',
  // social
  socialLinks: [
    {
      icon: 'fa fa-envelope',
      name: 'Email',
      url: 'mailto:fs468@cornell.edu'
    },
    {
      icon: 'ai ai-google-scholar',
      name: 'Google Scholar',
      url: 'https://scholar.google.com/citations?user=mYk4EZsAAAAJ',
    },
    {
      icon: 'fab fa-linkedin-in',
      name: 'Linked In',
      url: 'https://www.linkedin.com/in/farhana-shahid',
    },
  ],
  book: 'Books',
  music: 'Music',
  travel: 'Travel',
  job: 'Research',
};
